export default __webpack_public_path__ + "static/media/d036841bbcf690399a7bce867afe9a561581617017613.3c8ff8fd.webp";